<div id="msv-standing-auth-table">
  <sdps-tabs *ngIf="isTooManyRecords" sdps-id="sa-master-transaction-table-banner" id="sa-master-transaction-table-banner">
    <div class="msv-table-banner" id="msv-table-banner">
      <mm-banners [bannerText]="[atpReturnLimitMessage]" [type]="'information'"></mm-banners>
    </div>
  </sdps-tabs>
  <mm-table
    [columnDefs]="masterStandingAuthColumnDefs"
    [rowData]="rowData"
    [presetFilters]="filterModel"
    [rowHeight]="25"
    [fileName]="fileName"
    [showFloatingFilter]="true"
    [headerHeight]="25"
    [tableName]="'master standing authorizations'"
    [defaultColumnDefs]="currentSelectedTabDefaults"
    [showFilterCount]="true"
    [showTableOptions]="true"
    [componentState$]="masterStatusTableState$"
    (gridReadyEvent)="updateGridReady($event)"
    [noExportCol]="noExportCol"
    [accountNumber]="accountNumber"
  ></mm-table>
</div>
